import React, { useState, useEffect, useMemo, useCallback } from 'react';
import AsyncFetchSelect from 'components/common/select/AsyncFetchSelect';
import AsyncFetchSelectWithAll from 'components/common/select/AsyncFetchSelectWithAll';
import styled from 'styled-components';
import { useShallowAppSelector } from 'store/hooks';
import { useHistory } from 'react-router-dom';
import { pageUrl, exocadVersion } from 'lib/mapper';
import T from 'components/common/text/T';
import useInput from 'lib/hooks/useInput';
import { UserActions, UtilActions, PartnerActions, StatisticsActions } from 'store/actionCreators';
import { useDidUpdateEffect } from 'lib/utils';
import MuiWrapper from 'components/common/input/MuiWrapper';
import cx from 'classnames';
import { debounce } from 'lodash';
import { OffsetPagingData } from 'lib/types/sharedTypes';
import IconButton from '@material-ui/core/IconButton';
import { ITeethImplant, ITeethMaterial } from 'lib/types/sharedTypes';
import CustomSpan from 'components/common/text/CustomSpan';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import MuiButton from 'components/common/button/MuiButton';
import { useTranslation } from 'react-i18next';
import useCheckSetInput from 'lib/hooks/useCheckSetInput';
import PageTitle from 'components/base/title/PageTitle';
import { userCustomOption } from 'lib/mapper';

interface IInvoicePartner {
  email: string;
  isSelf: number;
  name: string;
  userGroupIdx: number;
}
interface IProjectPartners {
  accountType: number;
  isSelf: number;
  name: string;
  userGroupIdx: number;
  userGroupCode: string;
}

function KpiAddContainer() {
  const {
    user: { userGroupIdx: userId, groupCode, company },
    projectPartnersData: { list: projectPartnersList, pagingData: partnersPagingData },
    projectPartnersSuccess,
    projectPartnersPending,
    invoicePartnersData: { list: invoicePartnersList, pagingData: invoicePartnersPagingData },
    invoicePartnersSuccess,
    invoicePartnersPending,
    fetchIndicationInfo: {
      indicationInfo: { implantList: indicationImplants, materialList: indicationMaterials },
    },
    fetchIndicationInfoSuccess,
    createStatisticSuccess,
  }: {
    user: { userGroupIdx: string; groupCode: string; company: string };
    projectPartnersData: { list: IProjectPartners[]; pagingData: OffsetPagingData };
    projectPartnersSuccess: boolean;
    projectPartnersPending: boolean;
    invoicePartnersData: { list: IInvoicePartner[]; pagingData: OffsetPagingData };
    invoicePartnersSuccess: boolean;
    invoicePartnersPending: boolean;
    fetchIndicationInfo: {
      indicationInfo: {
        implantList: ITeethImplant[];
        materialList: ITeethMaterial[];
      };
    };
    fetchIndicationInfoSuccess: boolean;
    createStatisticSuccess: boolean;
  } = useShallowAppSelector(state => ({
    user: state.user.user || {},
    projectPartnersData: state.partner.projectPartners.data || {},
    projectPartnersSuccess: state.partner.projectPartners.success,
    projectPartnersPending: state.partner.projectPartners.pending,
    invoicePartnersData: state.partner.invoicePartners.data || {},
    invoicePartnersSuccess: state.partner.invoicePartners.success,
    invoicePartnersPending: state.partner.invoicePartners.pending,
    fetchIndicationInfo: state.util.indicationInfo.data || { indicationInfo: {} },
    fetchIndicationInfoSuccess: state.util.indicationInfo.success,
    createStatisticSuccess: state.statistics.createStatistic.success,
  }));
  const { t } = useTranslation();
  const history = useHistory();

  const clientKeyword = useInput('');
  const selectedClient = useInput('');
  const selectedClientInit = useInput(false);
  // const [selectedClientInit, setSelectedClientInit] = useState<boolean>(false);
  const [type, setType] = useState<number>(0);
  const [duration, setDuration] = useState<number>(0);
  const [groupOption, setGgoupOption] = useState<number>(0);
  const [dataOption, setDataOption] = useState<number>(0);
  const [dataOptionCheck, setDataOptionCheck] = useState<boolean>(false);
  const materials = useCheckSetInput(new Set([]));
  const [isMaterialsAll, setIsMaterialsAll] = useState<boolean>(false);
  const abutments = useCheckSetInput(new Set([]));
  const [isAbutmentsAll, setIsAbutmentsAll] = useState<boolean>(false);
  const [materialListCt, setMaterialListCt] = useState<ITeethMaterial[]>([]);

  const projectPartnerKeyword = useInput('');
  const typeList = [
    { idx: 0, type: 'PRODUCTIVITY' },
    { idx: 1, type: 'QUALITY' },
    { idx: 2, type: 'DELIVERY' },
    { idx: 3, type: 'DELIVERYDEADLINECOMPLIANCE' },
  ];
  const durationList = [
    { idx: 0, type: 'M' },
    { idx: 1, type: 'W' },
  ];
  const groupOptionList = [
    { idx: 0, type: 'PROJECTCOUNT' },
    { idx: 1, type: 'TEETHCOUNT' },
  ];

  const dataOptionList = [
    { idx: 0, type: 'REMAKE' },
    { idx: 1, type: 'REWORK' },
    { idx: 2, type: 'BOTH' },
  ];

  const kpiImplantList = [
    { idx: 7, name: 'None' },
    { idx: 8, name: 'Custom Abutment' },
    { idx: 9, name: 'Screw retained' },
    { idx: 10, name: 'On substructure' },
    { idx: 11, name: 'On Abutment' },
  ];

  const hideMeterailIndex = [
    { idx: 0 },
    { idx: 15 },
    { idx: 16 },
    { idx: 17 },
    { idx: 18 },
    { idx: 19 },
    { idx: 20 },
    { idx: 21 },
  ];
  const [projectPartners, setProjectPartners] = useState<IProjectPartners[]>([]);
  const setProjectPartnersValue = useMemo(
    () => projectPartnersSuccess && setProjectPartners(draft => draft.concat(projectPartnersList)),
    [!!projectPartnersSuccess],
  );

  const hasMoreProjectPartners = partnersPagingData?.page < partnersPagingData?.totalPage;

  const onFetchProjectPartners = debounce((first?: boolean) => {
    // if (first) return PartnerActions.fetch_sync_partners_request({ keyword: '', page: 1 });
    if (first) return PartnerActions.fetch_project_partners_request({ keyword: '', page: 1 });

    const { page, totalPage } = partnersPagingData;
    if (page >= totalPage) return;
    PartnerActions.fetch_project_partners_request({
      keyword: projectPartnerKeyword.value || '',
      page: page + 1,
    });
    // PartnerActions.fetch_sync_partners_request({
    //   keyword: projectPartnerKeyword.value || '',
    //   page: page + 1,
    // });
  }, 500);

  const onSearchProjectPartners = debounce((value: string) => {
    // console.log('projectPartnerKeyword.value', projectPartnerKeyword.value);
    console.log('onSearchProjectPartners ______ ', value);
    projectPartnerKeyword.setValue(value);
    // setSyncPartners([]);
    setProjectPartners([]);
    // PartnerActions.fetch_sync_partners_request({ keyword: value || '', page: 1 });
    PartnerActions.fetch_project_partners_request({ keyword: value || '', page: 1 });
  }, 500);

  const [invoicePartners, setInvoicePartners] = useState<IInvoicePartner[]>([]);
  // eslint-disable-next-line
  const setInvoicePartnersValue = useMemo(() => {
    return invoicePartnersSuccess && setInvoicePartners(draft => draft.concat(invoicePartnersList));
  }, [!!invoicePartnersSuccess]);

  const hasMoreInvoicePartners =
    invoicePartnersPagingData?.page < invoicePartnersPagingData?.totalPage;

  const onFetchInvoicePartners = debounce((first?: boolean) => {
    if (first) return PartnerActions.fetch_invoice_partners_request({ keyword: '', page: 1 });

    const { page, totalPage } = invoicePartnersPagingData;
    if (page >= totalPage) return;
    PartnerActions.fetch_invoice_partners_request({
      keyword: clientKeyword.value || '',
      page: page + 1,
    });
  }, 500);

  const handleChangeKpiType = (index: number) => {
    setType(index);
    // init setting
    materials.setValue(new Set([]));
    abutments.setValue(new Set([]));
    setIsMaterialsAll(false);
    setIsAbutmentsAll(false);
    setDuration(0);
    setGgoupOption(0);
    setDataOption(0);
    selectedClientInit.setValue(true);
    clientKeyword.setValue('');
    selectedClient.setValue('');
  };

  const onSearchInvoicePartners = debounce((value: string) => {
    // console.log('salesPartnerKeyword.value', salesPartnerKeyword.value);
    clientKeyword.setValue(value);
    setInvoicePartners([]);
    PartnerActions.fetch_invoice_partners_request({ keyword: value || '', page: 1 });
  }, 500);

  const handleCheckAllMaterials = (checkAll: boolean) => {
    // Check All click 시 일단 초기화
    materials.setValue(new Set([]));
    setIsMaterialsAll(!checkAll);
    if (!checkAll) {
      materialListCt.forEach((item: any) => {
        materials.onChange({ value: item.alias });
      });
    }
  };

  const handleCheckMaterials = (alias: string) => {
    materials.onChange({ value: alias });
  };

  const handleCheckAllAbutments = (checkAll: boolean) => {
    // Check All click 시 일단 초기화
    abutments.setValue(new Set([]));
    setIsAbutmentsAll(!checkAll);
    if (!checkAll) {
      indicationImplants.forEach((item: any) => {
        abutments.onChange({ value: item.alias });
      });
    }
  };

  const handleCheckAbutments = (alias: string) => {
    abutments.onChange({ value: alias });
  };

  // const handleSubmitKpiGraph = useCallback(() => {}, []);
  const handleSubmitKpiGraph = () => {
    const submitData = {
      version: exocadVersion,
      clientGroupCode: !!selectedClient.value ? selectedClient.value : null,
      type: typeList.find(item => item.idx === type)?.type,
      material: [...materials.value],
      implant: [...abutments.value],
      duration: durationList.find(item => item.idx === duration)?.type,
      groupOption: groupOptionList.find(item => item.idx === groupOption)?.type,
      dataOption: type === 1 ? dataOptionList.find(item => item.idx === dataOption)?.type : null,
    };

    // console.log('handleSubmitKpiGraph __________ ', submitData);
    StatisticsActions.create_statistics_graph_request(submitData);
  };

  useEffect(() => {
    if (!dataOptionCheck) {
      setDataOption(0);
    } else {
      setDataOption(2);
    }
  }, [dataOptionCheck]);

  useDidUpdateEffect(() => {
    // Material check 시, size 비교를 통한  all 측정
    if (materials.value.size === materialListCt.length) {
      setIsMaterialsAll(true);
    } else {
      setIsMaterialsAll(false);
    }
  }, [materials.value, isMaterialsAll, materialListCt]);

  useDidUpdateEffect(() => {
    // Abutment check 시, size 비교를 통한  all 측정
    if (abutments.value.size === indicationImplants.length) {
      setIsAbutmentsAll(true);
    } else {
      setIsAbutmentsAll(false);
    }
  }, [abutments.value, isAbutmentsAll, indicationImplants]);

  useEffect(() => {
    // UtilActions.fetch_teeth_indication_info_request();
    PartnerActions.fetch_project_partners_request({ keyword: '', page: 1 });
  }, []);
  useEffect(() => {
    // init
    UtilActions.fetch_teeth_indication_format_request({
      groupCode: !!groupCode ? groupCode : '',
    });
    UtilActions.fetch_teeth_indication_info_request({
      groupCode: !!groupCode ? groupCode : '',
    });
  }, [groupCode]);

  // useDidUpdateEffect(() => {
  //   if (!projectPartnersSuccess) return;
  //   console.log('partnersPagingData?.page _____ ', partnersPagingData?.page);
  //   if (partnersPagingData?.page === 1) {
  //     console.log('partnersPagingData?.page 1');
  //   }
  // }, [projectPartnersSuccess]);

  useDidUpdateEffect(() => {
    if (createStatisticSuccess) {
      history.push(pageUrl.kpi.list);
    }
  }, [createStatisticSuccess]);

  useDidUpdateEffect(() => {
    if (fetchIndicationInfoSuccess) {
      // 안쓰이는 Material Filtering
      const filteredMaterials: any[] = indicationMaterials.filter(material => {
        return !hideMeterailIndex.find(item => item.idx === material.idx);
      });
      setMaterialListCt([...filteredMaterials]);
    }
  }, [fetchIndicationInfoSuccess]);

  useEffect(() => {
    console.log('selectedValue ________ ', selectedClient.value);
  }, [selectedClient.value]);

  return (
    <StyledKpiAdd data-component-name="KpiAdd">
      <PageTitle title={t('NAV_MENU_KPI')} />
      <div className="KpiAddContainer__title_box">
        <h1 className="KpiAddContainer__title">
          <T>KPI_ADD_GRAPH</T>
        </h1>
      </div>
      <div className="KpiAddContainer__container">
        <div className="KpiAddContainer__type_tab_wrapper">
          <div className="KpiAddContainer__type_tab_item_box">
            <IconButton
              className={cx('KpiAddContainer__type_tab_item', {
                active: type === 0,
              })}
              onClick={() => {
                handleChangeKpiType(0);
              }}
            >
              <T>KPI_CATEGORY_PRODUCTIVITY</T>
            </IconButton>
          </div>
          <div className="KpiAddContainer__type_tab_item_box">
            <IconButton
              className={cx('KpiAddContainer__type_tab_item', {
                active: type === 1,
              })}
              onClick={() => {
                handleChangeKpiType(1);
              }}
            >
              <T>KPI_CATEGORY_QUALITY</T>
            </IconButton>
          </div>
          <div className="KpiAddContainer__type_tab_item_box">
            <IconButton
              className={cx('KpiAddContainer__type_tab_item', {
                active: type === 2,
              })}
              onClick={() => {
                handleChangeKpiType(2);
              }}
            >
              <T>KPI_CATEGORY_LEADTIME</T>
            </IconButton>
          </div>
          <div className="KpiAddContainer__type_tab_item_box">
            <IconButton
              className={cx('KpiAddContainer__type_tab_item', {
                active: type === 3,
              })}
              onClick={() => {
                handleChangeKpiType(3);
              }}
            >
              <T>KPI_CATEGORY_DELIVERYDEADLINECOMPLIANCE</T>
            </IconButton>
          </div>
        </div>

        <div className="KpiAddContainer__select_list_wrapper">
          <div className="KpiAddContainer__select_row client">
            <div className="KpiAddContainer__select_row_label">
              <T>GLOBAL_CLIENT</T>
            </div>
            <div className="KpiAddContainer__select_row_contents">
              {/* <AsyncFetchSelect
                className="sm client_select_box"
                fullWidth
                // fontColor="white"
                // borderColor="white"
                // hoverBorderColor="white"
                // activeBorderColor="white"
                // bgColor="transparent"
                // loadingIconColor="white"
                // dropIconColor="white"
                inputProps={{
                  hasInitialValue: true,
                  selectedValue: selectedClient.value,
                  setSelectedValue: selectedClient.setValue,
                  data: projectPartners,
                  hasMoreData: hasMoreProjectPartners,
                  idKey: 'userGroupCode',
                  labelKey: 'name',
                  // exceptId: orderType.value === '0' ? userGroupIdx : '',
                  onFetch: onFetchProjectPartners,
                  searchLoading: projectPartnersPending,
                  onSearch: onSearchProjectPartners,
                  isInitValue: selectedClientInit.value,
                  setIsInitValue: selectedClientInit.setValue,
                }}
              /> */}
              <AsyncFetchSelectWithAll
                className="sm client_select_box"
                fullWidth
                inputProps={{
                  hasInitialValue: true,
                  selectedValue: selectedClient.value,
                  setSelectedValue: selectedClient.setValue,
                  data: projectPartners,
                  hasMoreData: hasMoreProjectPartners,
                  initialValueName: t('GLOBAL_ALL'),
                  idKey: 'userGroupCode',
                  labelKey: 'name',
                  onFetch: onFetchProjectPartners,
                  searchLoading: projectPartnersPending,
                  onSearch: onSearchProjectPartners,
                  isInitValue: selectedClientInit.value,
                  setIsInitValue: selectedClientInit.setValue,
                }}
              />
              {/* {useMemo(
                () => (
                ),
                [projectPartners],
              )} */}
            </div>
          </div>

          <div className="KpiAddContainer__select_row">
            <div className="KpiAddContainer__select_row_label">
              <T>GLOBAL_MATERIAL</T>
            </div>
            <div className="KpiAddContainer__select_row_contents">
              <div className="contents_check_box_wrapper all">
                <FormControlLabel
                  // className="contents_check_box_wrapper all"
                  control={
                    <MuiWrapper>
                      <Checkbox
                        checked={isMaterialsAll}
                        onChange={() => {
                          handleCheckAllMaterials(isMaterialsAll);
                        }}
                        className="checkbox_control_checkbox"
                        name="materail"
                        color="primary"
                        icon={<div className="custom_checkbox"></div>}
                      />
                    </MuiWrapper>
                  }
                  label={
                    <CustomSpan fontSize={14}>
                      <T>GLOBAL_ALL</T>
                    </CustomSpan>
                  }
                />
              </div>

              {materialListCt?.map((material: ITeethMaterial) => {
                return (
                  <div className="contents_check_box_wrapper" key={material.idx}>
                    <FormControlLabel
                      // className="contents_check_box_wrapper"
                      control={
                        <MuiWrapper>
                          <Checkbox
                            checked={materials.value.has(material.alias)}
                            onChange={() => {
                              handleCheckMaterials(material.alias);
                            }}
                            className="checkbox_control_checkbox"
                            name={material.alias}
                            color="primary"
                            icon={<div className="custom_checkbox"></div>}
                          />
                        </MuiWrapper>
                      }
                      label={
                        <CustomSpan fontSize={14}>
                          {material?.alias.split('_')[0] === userCustomOption.material
                            ? material.name
                            : t(`MATERIAL_${material?.alias}`)}
                        </CustomSpan>
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>

          <div className="KpiAddContainer__select_row abutment">
            <div className="KpiAddContainer__select_row_label">
              <T>GLOBAL_ABUTMENT</T>
            </div>
            <div className="KpiAddContainer__select_row_contents">
              <div className="contents_check_box_wrapper all">
                <FormControlLabel
                  // className="contents_check_box_wrapper all"
                  control={
                    <MuiWrapper>
                      <Checkbox
                        checked={isAbutmentsAll}
                        onChange={() => {
                          handleCheckAllAbutments(isAbutmentsAll);
                        }}
                        className="checkbox_control_checkbox"
                        name="abutment"
                        color="primary"
                        icon={<div className="custom_checkbox"></div>}
                      />
                    </MuiWrapper>
                  }
                  label={
                    <CustomSpan fontSize={14}>
                      <T>GLOBAL_ALL</T>
                    </CustomSpan>
                  }
                />
              </div>

              {indicationImplants?.map((implant: ITeethImplant) => {
                return (
                  <div className="contents_check_box_wrapper" key={implant.idx}>
                    <FormControlLabel
                      // className="contents_check_box_wrapper"
                      control={
                        <MuiWrapper>
                          <Checkbox
                            checked={abutments.value.has(implant.alias)}
                            onChange={() => {
                              handleCheckAbutments(implant.alias);
                            }}
                            className="checkbox_control_checkbox"
                            name={implant.alias}
                            color="primary"
                            icon={<div className="custom_checkbox"></div>}
                          />
                        </MuiWrapper>
                      }
                      label={
                        <CustomSpan fontSize={14}>
                          {/* {implantName} */}
                          {t(`ABUTMENT_IMPLANT_${implant?.alias}`)}
                        </CustomSpan>
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>

          <div className="KpiAddContainer__select_row duration">
            <div className="KpiAddContainer__select_row_label">
              <T>KPI_GROUP_UNIT</T>
            </div>
            <div className="KpiAddContainer__select_row_contents duration">
              <IconButton
                className={cx('contents_button_item ', {
                  active: duration === 0,
                })}
                onClick={() => {
                  setDuration(0);
                }}
              >
                <CustomSpan fontSize={14} fontWeight={500}>
                  <T>GLOBAL_MONTHLY</T>
                </CustomSpan>
              </IconButton>
              <IconButton
                className={cx('contents_button_item ', {
                  active: duration === 1,
                })}
                onClick={() => {
                  setDuration(1);
                }}
              >
                <CustomSpan fontSize={14} fontWeight={500}>
                  <T>GLOBAL_WEEKLY</T>
                </CustomSpan>
              </IconButton>
            </div>
          </div>

          <div className="KpiAddContainer__select_row groupOption">
            <div className="KpiAddContainer__select_row_label">
              <T>GLOBAL_NUMBER</T>
            </div>
            <div className="KpiAddContainer__select_row_contents groupOption">
              <IconButton
                className={cx('contents_button_item ', {
                  active: groupOption === 0,
                })}
                onClick={() => {
                  setGgoupOption(0);
                }}
              >
                <CustomSpan fontSize={14} fontWeight={500}>
                  <T>GLOBAL_PROJECTS</T>
                </CustomSpan>
              </IconButton>
              <IconButton
                className={cx('contents_button_item ', {
                  active: groupOption === 1,
                })}
                onClick={() => {
                  setGgoupOption(1);
                }}
              >
                <CustomSpan fontSize={14} fontWeight={500}>
                  <T>GLOBAL_TEETH</T>
                </CustomSpan>
              </IconButton>
            </div>
          </div>

          {type === 1 && (
            <div className="KpiAddContainer__select_row rework">
              <div className="KpiAddContainer__select_row_label">
                <T>GLOBAL_REWORK</T>
              </div>
              <div className="KpiAddContainer__select_row_contents">
                <div className="contents_check_box_wrapper all">
                  <FormControlLabel
                    // className="contents_check_box_wrapper all"
                    control={
                      <MuiWrapper>
                        <Checkbox
                          checked={dataOptionCheck}
                          onChange={() => {
                            // setDataOption(2);
                            setDataOptionCheck(!dataOptionCheck);
                          }}
                          className="checkbox_control_checkbox"
                          name={'All'}
                          color="primary"
                          icon={<div className="custom_checkbox"></div>}
                        />
                      </MuiWrapper>
                    }
                    label={
                      <CustomSpan fontSize={14}>
                        <T>KPI_INCLUDE_REWORK_ITEM</T>
                      </CustomSpan>
                    }
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="KpiAddContainer__button_container">
        <MuiButton
          config={{
            width: 360,
          }}
          className="KpiAddContainer__button cancel"
          variant="outlined"
          color="primary"
          onClick={() => {
            history.push(pageUrl.kpi.list);
          }}
        >
          <T>GLOBAL_CANCEL</T>
        </MuiButton>

        <MuiButton
          config={{
            width: 360,
          }}
          className="KpiAddContainer__button add"
          variant="contained"
          color="primary"
          disabled={!materials.value.size || !abutments.value.size}
          onClick={handleSubmitKpiGraph}
        >
          <T>GLOBAL_ADD</T>
        </MuiButton>
      </div>
    </StyledKpiAdd>
  );
}
const StyledKpiAdd = styled.section<{}>`
  /* margin-top: 30px; */
  margin-bottom: 230px;

  .KpiAddContainer__title_box {
    .KpiAddContainer__title {
      font-size: 26px;
      font-weight: 500;
    }
  }

  .KpiAddContainer__container {
    margin-top: 30px;
    margin-bottom: 40px;
  }
  .KpiAddContainer__type_tab_wrapper {
    /* width: 1600px; */
    width: 100%;
    height: 60px;
    display: flex;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 16%);
    background-color: #ffffff;
    .KpiAddContainer__type_tab_item_box {
      width: 33.3%;
      height: 60px;
      overflow: hidden;
      border-left: 1px solid #e1e1e1;
      &:first-child {
        border-top-left-radius: 10px;
        border-top-right-radius: 0;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 0;
      }

      &:last-child {
        border-top-left-radius: 0;
        border-top-right-radius: 10px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 10px;
      }
      .KpiAddContainer__type_tab_item {
        width: 100%;
        height: 60px;
        border-radius: 0;
        color: #222;
        font-size: 16px;
        /* font-weight: 500; */
        &.active {
          color: #fff;
          background-color: #00a6e2;
        }
      }
    }
  }

  .KpiAddContainer__select_list_wrapper {
    margin-top: 20px;
    /* width: 1600px; */
    width: 100%;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 16%);
    padding: 60px;
    display: flex;
    flex-direction: column;
    row-gap: 60px;
    background-color: #ffffff;
    .KpiAddContainer__select_row {
      display: flex;
      .KpiAddContainer__select_row_label {
        width: 185px;
        display: flex;
        align-items: center;
        height: 40px;
        font-size: 15px;
        font-weight: 500;
      }
      .KpiAddContainer__select_row_contents {
        width: calc(100% - 185px);
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        row-gap: 10px;
        .client_select_box {
          width: 320px;
        }

        .contents_check_box_wrapper {
          /* width: 42px; */
          /* margin-right: 20px; */
          width: 200px;
          /* height: 20px; */
          height: 40px;
          &.all {
            width: 100%;
            height: 40px;
          }

          .checkbox_control_checkbox {
            width: 42px;
            height: 42px;
          }
        }
        .custom_checkbox {
          width: 20px;
          height: 20px;
          border: 1px solid #e5e7ed;
          border-radius: 4px;
        }
        &.duration,
        &.groupOption {
          column-gap: 10px;
        }

        .contents_button_item {
          width: 180px;
          height: 40px;
          border-radius: 5px;
          border: solid 1px #dddee4;
          &.active {
            color: #fff;
            background-color: #00a6e2;
          }
        }
      }
    }
  }

  .KpiAddContainer__button_container {
    display: flex;
    column-gap: 10px;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    .KpiAddContainer__button {
      box-shadow: none;
    }
  }
`;
export default React.memo(KpiAddContainer);
